import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router";
import App from "./App.tsx";
import Home from "./pages/Home.tsx";
import Product from "./pages/Product.tsx";
import Cart from "./pages/Cart.tsx";

// 后台只有管理员会打开,它依赖的图表库不该跟着商品页一起下载:按需加载
const Admin = lazy(() => import("./pages/Admin.tsx"));

/** 路由表。浏览器入口和服务端入口共用，只是外面套的 Router 不同 */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<App />}>
        <Route index element={<Home />} />
        <Route path="p/:slug" element={<Product />} />
        <Route path="cart" element={<Cart />} />
        <Route path="admin" element={<Suspense fallback={<p className="empty">加载中…</p>}><Admin /></Suspense>} />
      </Route>
    </Routes>
  );
}
